export default __webpack_public_path__ + "static/media/university-unam-logo.131f95a9.png";